import { intelligentStatus } from '@/utils/contants/intelligentQA';
import s from './style.module.scss';

const Status = (props) => {
    const { intelligent_qa_status } = props;
    return (
        <>
            <div
                data-text={intelligent_qa_status?.label}
                className={`${s['tip-text']}  ${intelligent_qa_status?.status !== intelligentStatus?.specificcontent ? 'loading-text' : ''}`}
            >
                {intelligent_qa_status?.label}
            </div>
        </>
    );
};
export default Status;
